import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLinewebtoonComponent } from './simple-icons-linewebtoon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLinewebtoonComponent ],
    exports:      [ SimpleIconsLinewebtoonComponent ],
    bootstrap:    []
})
export class SimpleIconsLinewebtoonModule {}
